export let baseApi = '/stdailynewspaperapi';

export const siteId = !window.location.href.includes('epaper.stdaily') ?'8b1ff0c0399945678173ea29a1212a54':'811c18b08cf04e79be3b67d6902ee1a7';
export const code='KJRB'
